import GraphGroup from "./graph_group";
import GraphContainer, { getOrSet, getOrSetVec } from "./graph_container";

class GraphRect extends GraphGroup {
    constructor({ fill = "transparent", x = 0, y = 0, width = 0, height = 0 } = {}) {
        super();

        this._origin = new THREE.Vector2(x, y);
        this._size = new THREE.Vector2(width, height);

        this._defs = GraphContainer.create("defs");
        this._clipPath = GraphContainer.create("clipPath").setAttribute("id", `clip_${this._uuid}`);
        this._clipRect = GraphContainer.create("rect");

        this._defs.append(this._clipPath);
        this._clipPath.append(this._clipRect);

        this._rect = GraphContainer.create("rect");

        this.append(this._defs)
            .append(this._rect);

        this._fill = fill;
    }

    /**
     * @returns {this}
     */
    origin() { return getOrSetVec.call(this, "_origin", ...arguments); }
    /**
     * @returns {this}
     */
    x() { return getOrSet.call(this, this._size, "x", ...arguments); }
    /**
     * @returns {this}
     */
    y() { return getOrSet.call(this, this._size, "y", ...arguments); }

    /**
     * @returns {this}
     */
    size() { return getOrSetVec.call(this, "_size", ...arguments); }
    /**
     * @returns {this}
     */
    width() { return getOrSet.call(this, this._size, "width", ...arguments); }
    /**
     * @returns {this}
     */
    height() { return getOrSet.call(this, this._size, "height", ...arguments); }
    /**
     * @returns {this}
     */
    fill() { return getOrSet.call(this, this, "_fill", ...arguments); }

    redraw() {
        [this._clipRect, this._rect].forEach(rect => {
            rect
                .setAttribute("x", this._origin.x)
                .setAttribute("y", this._origin.y)
                .setAttribute("width", this._size.width)
                .setAttribute("height", this._size.height)
                .setAttribute("fill", this._fill);
        });

        this._rect.setAttribute("clip-path", `url(#clip_${this._uuid})`);

        return this;
    }


}

export default GraphRect;
export { GraphRect };